// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HSkt","title":"styles_title__2m0ai"};